import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export function resolveUploadUrl(url) {
  if (!url || url.startsWith('http') || url.startsWith('blob:') || url.startsWith('data:')) return url;
  return `${API_URL}${url}`;
}

const apiClient = axios.create({
  baseURL: API_URL,
});

// Request interceptor to add token
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor to handle 401 and 402
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const requestUrl = error.config?.url || '';
      const isAuthEndpoint = requestUrl.includes('/api/auth/');
      const hasToken = !!localStorage.getItem('token');
      if (!isAuthEndpoint && hasToken) {
        if (window.logout) {
          window.logout();
        }
        window.location.href = '/login';
      }
    }
    if (error.response?.status === 402) {
      window.dispatchEvent(new CustomEvent('subscription-required', {
        detail: error.response.data,
      }));
    }
    return Promise.reject(error);
  }
);

export default apiClient;